import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pageBack",
  style: {"padding-left":"10px","padding-right":"10px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "标题填写")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("textarea", {
    maxlength: "50",
    class: "sizeTilte",
    placeholder: "请输入标题",
    id: "myInput"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "简要描述您的问题")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("textarea", {
    maxlength: "200",
    class: "sizeContent",
    id: "myText",
    placeholder: "请详细描述您的问题，我们会尽快对您反馈的问题进行答复和解决"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("textarea", {
    maxlength: "50",
    class: "sizeTilte",
    placeholder: "请留下您的联系方式，方便我们与您进行联系",
    id: "myPhone"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "提交举报", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      onClickLeft: _ctx.onClickLeft
    }, null, 8, ["onClickLeft"]),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("div", {
      class: "submit",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exposureSave()))
    }, _hoisted_13),
    _hoisted_14
  ]))
}